import { useEffect, useRef } from "react";

import { useToast } from "@go-novus/ui";

interface FailureNoticeOptions {
  /** TanStack 的 `errorUpdatedAt`：重试后再失败要能再弹一次，光看布尔量弹不出第二条。 */
  failedAt: number;
  /** 屏幕上已经有读到的内容没有。 */
  hasContent: boolean;
  message: string | null;
}

/**
 * 决定一次读失败摆在哪儿：已经有内容就弹 toast，内容原样留着；一条都没有才让调用方
 * 拿这句话铺满整块。翻页失败把已经读到的列表整个换掉，就是这个 hook 要挡的事。
 *
 * @returns 该铺满整块的失败文案；返回 null 表示失败已经弹成 toast 了。
 */
export function useFailureNotice({
  failedAt,
  hasContent,
  message,
}: FailureNoticeOptions): string | null {
  const toast = useToast();
  const toastedAt = useRef<number | null>(null);

  useEffect(() => {
    if (message === null || !hasContent || toastedAt.current === failedAt) {
      return;
    }

    toastedAt.current = failedAt;
    toast.add({ data: { tone: "error" }, title: message });
  }, [failedAt, hasContent, message, toast]);

  return hasContent ? null : message;
}
